import React from "react";
import styles from "./Amenities.module.scss";
import amenitiesList from './amenities.json';
// @ts-ignore
import * as AmenitiesImages from 'assets/img/amenities';

interface Props {
  amenities_ids?: string,
}

export const Amenities: React.FC<Props> = ({
  amenities_ids = '',
}) => {
  return (
    <>
      {amenities_ids.replace(/,/g, "").length > 0 ? (
        <div className={styles.amenities_container}>
          {amenities_ids.split(",").map((amenity: string, index: number) => {
            const amenitiesListWithIndexSignature: { [key: string]: string } =
              amenitiesList;
            const key =
              amenity === "39"
                ? "PetFriendly"
                : amenity === "37"
                ? "TwentyFourHours"
                : amenitiesListWithIndexSignature[amenity]?.replace(/\s/g, "");

            if (key) {
              return (
                <React.Fragment key={index}>
                  <div className={styles.amenity}>
                    <img src={AmenitiesImages[key]} alt={key} />
                    <span>{amenitiesListWithIndexSignature[amenity]}</span>
                  </div>
                </React.Fragment>
              );
            }

            return null;
          })}
        </div>
      ) : (
        <div className={styles.no_amenities}>No amenities</div>
      )}
    </>
  );
};
